(function (app) {

    app.provider("marketingTrackerSalesTrackerInputApi",
        [
            function () {
                this.$get = [
                    "marketingTrackerApiGateway", function (marketingTrackerApiGateway) {
                        var service = {};
                        //GETS
                        service.getSpendings = function (spendingId) {
                            return marketingTrackerApiGateway.get("/SalesTracker/Spendings/" + spendingId);
                        };
                        service.getSpendingsByDate = function (startDate, endDate) {
                            return marketingTrackerApiGateway.get("/SalesTracker/Spendings/?startDate=" + startDate + "&endDate=" + endDate);
                        };

                        service.getOpportunities = function (opportunityId) {
                            return marketingTrackerApiGateway.get("/SalesTracker/Opportunities/" + opportunityId);
                        };
                        service.getOpportunitiesByDate = function (startDate, endDate) {
                            return marketingTrackerApiGateway.get("/SalesTracker/Opportunities/?startDate=" + startDate + "&endDate=" + endDate);
                        };

                        service.getSales = function (saleId) {
                            return marketingTrackerApiGateway.get("/SalesTracker/Sales/" + saleId);
                        };
                        service.getSalesByDate = function (startDate, endDate) {
                            return marketingTrackerApiGateway.get("/SalesTracker/Sales/?startDate=" + startDate + "&endDate=" + endDate);
                        };

                        service.getPreviousSpendingNotes = function (q) {
                            return marketingTrackerApiGateway.get("/SalesTracker/Spendings/Notes?q=" + q);
                        };

                        service.getSpendingByAncillaryEventGroupId = function (ancillaryEventGroupId) {
                            return marketingTrackerApiGateway.get("/SalesTracker/Spendings/EventGroup?ancillaryEventGroupId=" + ancillaryEventGroupId);
                        }

                        service.getSpendingByEventGroupId = function (eventGroupId) {
                            return marketingTrackerApiGateway.get("/SalesTracker/Spendings/EventGroup?eventGroupId=" + eventGroupId);
                        }

                        service.getOpportunitySales = function (opportunityId) {
                            return marketingTrackerApiGateway.get("/SalesTracker/Opportunities/" + opportunityId + "/sales");
                        };

                        //POSTS
                        service.createSpending = function (spendingModel) {
                            return marketingTrackerApiGateway.post("/SalesTracker/Spendings", spendingModel);
                        };

                        service.addContact = function (contact) {
                            return marketingTrackerApiGateway.post("/Contacts", contact);
                        };

                        service.createOpportunity = function (opportunityModel) {
                            return marketingTrackerApiGateway.post("/SalesTracker/Opportunities", opportunityModel);
                        };

                        service.createSale = function (saleModel) {
                            return marketingTrackerApiGateway.post("/SalesTracker/Sales", saleModel);
                        };

                        //PUT
                        service.updateSaleAdvisors = function (saleModelId, advisors) {
                            return marketingTrackerApiGateway.put("/SalesTracker/Sales/" + saleModelId + "/Advisors/Update", advisors);
                        };

                        service.updateSaleLobAmounts = function (saleModelId, lineOfBusinessAmount) {
                            return marketingTrackerApiGateway.put("/SalesTracker/Sales/" + saleModelId + "/LinesOfBusiness", lineOfBusinessAmount);
                        };

                        service.updateSpending = function (spendingModel) {
                            return marketingTrackerApiGateway.put("/SalesTracker/Spendings/" + spendingModel.Id, spendingModel);
                        };

                        service.updateOpportunity = function (opportunityModel) {
                            return marketingTrackerApiGateway.put("/SalesTracker/Opportunities/" + opportunityModel.Id, opportunityModel);
                        };

                        service.updateOpportunityAdvisors = function (opportunityModelId, advisors) {
                            return marketingTrackerApiGateway.put("/SalesTracker/Opportunities/" + opportunityModelId + "/Advisors/Update", advisors);
                        };

                        service.updateSale = function (saleModel) {
                            return marketingTrackerApiGateway.put("/SalesTracker/Sales/" + saleModel.Id, saleModel);
                        };

                        //DELETE
                        service.deleteSpending = function (spendingId) {
                            return marketingTrackerApiGateway.delete("/SalesTracker/Spendings/" + spendingId);
                        };

                        service.deleteOpportunity = function (opportunityId) {
                            return marketingTrackerApiGateway.delete("/SalesTracker/Opportunities/" + opportunityId);
                        };

                        service.deleteSale = function (saleId) {
                            return marketingTrackerApiGateway.delete("/SalesTracker/Sales/" + saleId);
                        };

                        // EXPORTS
                        service.postExportSpendings = function (startDate, endDate) {
                            return marketingTrackerApiGateway.getFilePost("/SalesTracker/Spendings/Export/?startDate=" + startDate + "&endDate=" + endDate);
                        };


                        service.postExportOpportunities = function (startDate, endDate) {
                            return marketingTrackerApiGateway.getFilePost("/SalesTracker/Opportunities/Export/?startDate=" + startDate + "&endDate=" + endDate);
                        };

                        service.postExportSales = function (startDate, endDate) {
                            return marketingTrackerApiGateway.getFilePost("/SalesTracker/Sales/Export/?startDate=" + startDate + "&endDate=" + endDate);
                        };

                        return service;
                    }
                ];
            }
        ]);
})(window.app); //jshint ignore:line